/**
 *
 * Copyright © 2017 Easymeeting AS. All rights reserved.
 *
 * This software is produced by Easymeeting AS.
 * Unauthorized redistribution, reproduction, or usage of
 * this software in whole or in part without the express
 * written consent of Easymeeting AS is strictly prohibited.
 */
import { mapActions, mapGetters } from 'vuex';
import contactMixin from '@/mixins/contact';

export default {
  name: 'Contact',
  mixins: [contactMixin],
  props: {
    contact: {
      type: Object,
      default: null
    }
  },
  computed: {
    ...mapGetters('ConversationStore', {
      conversations: 'conversations',
      notificationList: 'notificationList'
    }),
    conversation () {
      if (this.contact && this.contact.userhash) {
        return this.conversations.find(elem => {
          return !elem.group && elem.participants && elem.participants[0] && elem.participants[0].userhash === this.contact.userhash;
        });
      }
      return null;
    },
    hasNotification () {
      return !!this.notificationList.find(elem => this.conversation && elem === this.conversation.conversationID);
    },
    showContactChatButton () {
      return this.user && this.contact && this.contact.userhash;
    }
  },
  mounted () {
    this.$eventBus.$on('native-messageFromControl', this.onMessageFromControl);
  },
  beforeDestroy () {
    this.$eventBus.$off('native-messageFromControl', this.onMessageFromControl);
  },
  methods: {
    ...mapActions('ConversationStore', {
      createConversation: 'createConversation',
      setConversationInfo: 'setConversationInfo'
    }),
    goback (mouseMovement, fromControl = false) {
      if (!fromControl) {
        this.$eventBus.$emit('sendToControls', {
          type: 'task',
          scope: 'contact',
          data: {
            task: 'goback'
          }
        });
      }
      this.$emit('exit');
    },
    gotoChat () {
      if (this.conversation) {
        this.setConversationInfo(this.conversation);
        this.goback();
        this.$eventBus.$emit('goto-chat-tab');
      } else if (this.contact.userhash) {
        const data = {
          userHashes: [this.contact.userhash],
          isGroup: false
        };
        this.createConversation(data);
        this.goback();
        this.$eventBus.$emit('goto-chat-tab');
      }
    },
    startCall (mouseMovement, fromControl = false) {
      if (!fromControl) {
        this.$eventBus.$emit('sendToControls', {
          type: 'task',
          scope: 'contact',
          data: {
            task: 'startCall'
          }
        });
      }
      this.goback();
      this.$eventBus.$emit('goto-webrtc-page', this.contact);
    },
    callFromMeeting (mouseMovement, fromControl = false) {
      if (!fromControl) {
        this.$eventBus.$emit('sendToControls', {
          type: 'task',
          scope: 'contact',
          data: {
            task: 'callFromMeeting'
          }
        });
      }
      this.$eventBus.$emit('meeting-invite-user', this.contact);
      this.goback();
    },
    onMessageFromControl ({ message }) {
      try {
        if (message.scope === 'contact') {
          if (message.type === 'task') {
            switch (message.data.task) {
              case 'goback':
                this.goback(null, true);
                break;
              case 'startCall':
                this.startCall(null, true);
                break;
              case 'callFromMeeting':
                this.callFromMeeting(null, true);
                break;
              case 'removeParticipant':
                this.removeParticipant(null, true);
                break;
              case 'onAddToContact':
                this.onAddToContact();
                break;
              case 'onRemoveContact':
                this.onRemoveContact();
                break;
              case 'onAddToFav':
                this.onAddToFav();
                break;
              case 'onRemoveFav':
                this.onRemoveFav();
                break;
            }
          }
        }
      } catch (err) {}
    },
    removeParticipant (mouseMovement, fromControl = false) {
      if (!fromControl) {
        this.$eventBus.$emit('sendToControls', {
          type: 'task',
          scope: 'contact',
          data: {
            task: 'removeParticipant'
          }
        });
      }
      this.$eventBus.$emit('meeting-remove-participant', this.contact);
      this.goback();
    },
    toggleContact () {
      if (!this.contact.isMyContact) {
        this.onAddToContact();
      } else {
        this.onRemoveContact();
      }
    },
    toggleFav () {
      if (this.contact.isfav) {
        this.onRemoveFav();
      } else {
        this.onAddToFav();
      }
    }
  }
};
